import { render, staticRenderFns } from "./StatisticsChartPanel.vue?vue&type=template&id=5a30f9d4"
import script from "./StatisticsChartPanel.vue?vue&type=script&lang=js"
export * from "./StatisticsChartPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports